import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useManufactureMutation } from '@http';
import { Modal } from '@components/ui/Modal';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { useState } from 'react';

interface CraftButtonProps {
  resources: Shared.Crafting['resources'];
  id: string;
};

export function CraftButton({ resources, id }: CraftButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Forge' });
  const { mutateAsync } = useManufactureMutation();
  const { userData, refetch } = useAppStore();

  const canForge = Object
    .entries(resources)
    .every(([key, value]) => (userData.items.find(i => i.key === key)?.amount ?? 0) >= value);

  const tryForge = () => {
    if (!canForge) return;
    setShowConfirm(true);
  };

  const close = () => setShowConfirm(false);
  const confirm = async () => {
    setIsLoading(true);

    await mutateAsync({ id });

    setIsLoading(false);
    setShowConfirm(false);

    refetch();
  };

  return (
    <>
      <Modal onRequestClose={() => setShowConfirm(false)} title={t('confirmCraft')} isOpen={showConfirm}>
        <p className="text-center my-4 text-sm px-4">{t('confirmCraftMessage')}</p>
        <div className="flex justify-center mt-4">
          <Button className="border-l-0 border-b-0" isLoading={isLoading} onClick={close}>
            {t('cancel')}
          </Button>
          <Button className="border-x-0 border-b-0" isLoading={isLoading} onClick={confirm}>
            {t('submit')}
          </Button>
        </div>
      </Modal>

      <button className={`${canForge && 'can-buy'} market-listing-btn`} onClick={tryForge}>
        <p className={`${!canForge && 'text-gray-500'} text-sm text-center w-full`}>
          {t(canForge ? 'craft' : 'notEnoughResources')}
        </p>
      </button>
    </>
  );
}